<tr>
  <td class="ikon">
    <mat-icon>folder</mat-icon>
    @if(mappe().skjerming.skjermedeMedlemmerId.length > 0){
      <mat-icon class="skjermet" (click)="visSkjerming()" matTooltip="{{'Mappen er skjult for {antall} medlemmer'| translate: {antall: mappe().skjerming.skjermedeMedlemmerId.length} }}">visibility_lock</mat-icon>
    }
  </td>
  <td class="navn" colspan="5"> {{ mappe().navn }}</td>
  <th><!-- handlinger --></th>
  <td class="meny">
    @if(redigeringMulig()){
    <button mat-icon-button [matMenuTriggerFor]="meny.matMeny()" (click)="$event.stopPropagation()" class="mat-medium-icon-button meny">
      <mat-icon class="material-symbols-fet">more_vert</mat-icon>
    </button>
    <arkivmappe-meny [mappe]="mappe()" #meny/>
    }
  </td>
</tr>
